import { createRestApi } from './rest';
import { Media as MediaProps } from '~/types/api';

const mediaBaseUrl = '/api/v2/media';
const stockMediaBaseUrl = '/api/v2/stock-media';

export const createStockMediaApi = () =>
  createRestApi<MediaProps>(stockMediaBaseUrl);
export const createMediaApi = () => createRestApi<MediaProps>(mediaBaseUrl);
export default createMediaApi;
